import {Component, inject, OnChanges, SimpleChanges, input, output} from '@angular/core';

import {MultiSelectModule} from 'primeng/multiselect';
import {CountryCode} from '@frontend/directus';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {CountryService} from '@frontend/shared';

interface CountryWithDisplayName extends CountryCode {
  displayName: string;
  flagUrl: string;
}

@Component({
  selector: 'app-country-multiselect',
  imports: [MultiSelectModule, FormsModule, TranslocoPipe],
  templateUrl: './country-multiselect.component.html',
})
export class CountryMultiselectComponent implements OnChanges {
  readonly countries = input<CountryCode[]>([]);
  readonly preSelectedCountries = input<CountryCode[]>([]);

  readonly selectedCountriesChange = output<CountryCode[]>();

  availableCountries: CountryWithDisplayName[] = [];
  selectedCountries: CountryWithDisplayName[] = [];
  readonly countryService = inject(CountryService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countries']) {
      this.updateAvailableCountries();
    }
    if (changes['preSelectedCountries']) {
      this.updateSelectedCountries();
    }
  }

  private updateAvailableCountries(): void {
    const sortedCountries = this.countryService.getSortedCountries(this.countries());
    this.availableCountries = sortedCountries.map((country) => ({
      ...country,
      displayName: this.countryService.getCountryDisplayName(country),
      flagUrl: this.countryService.getCountryFlagUrl(country.isoCode),
    }));
    this.updateSelectedCountries();
  }

  private updateSelectedCountries(): void {
    const selectedCodes = new Set(this.preSelectedCountries().map((c) => c.isoCode));
    this.selectedCountries = this.availableCountries.filter((c) => selectedCodes.has(c.isoCode));
  }

  onSelectionChange(): void {
    const originalCountries: CountryCode[] = this.selectedCountries.map(
      ({displayName, flagUrl, ...country}) => country,
    );
    this.selectedCountriesChange.emit(originalCountries);
  }
}
